/**
 * Import required libraries
 */
import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router";

/**
 * Import required elements
 */
import { Loading } from "Components";
import WaitData from "./waitdata"

const Home = lazy(() => import("./Home"));
const Landing = lazy(() => import("./Landing"));
const PartialLanding = lazy(() => import("./Landing/Login"));
const Project = lazy(() => import("./Project"));

/**
 * Routes Render JSX
 */
const Routes = React.memo(({ logged, authenticated }) => {
  return (
    <Suspense fallback={<Loading absolute />}>
      <Switch>
        <Route
          path="/project/:uid"
          component={(logged || authenticated) ? Project : PartialLanding} />
        <Route component={logged ? Home : Landing} />
      </Switch>
    </Suspense>
  );
})

export default React.memo(({ logged, authenticated, navigation, socketInterrupted }) => {
  const routes = navigation === "init" ? (
    <Loading absolute />
  ) : (
    <Routes
      logged={logged}
      authenticated={authenticated}
    />
  )
  if (!logged) return routes
  else return <WaitData>{routes}</WaitData>
})
